import React, { useState } from "react";
// import {
//   PulseButton,
//   PulseButtonTheme,
//   PulseTextField,
//   PulseDropdown,
// } from "@pulselabs-ai/shared-fe-ui";
import "./DesignSystemPage.scss";
import { Typography } from "../Typography/Typography";
import { FoundationColors } from "../Colors/FoundationColors";
import { SemanticColors } from "../Colors/SemanticColors";
import { MarginExamples } from "../Spacing/MarginExamples";
import { PaddingExamples } from "../Spacing/PaddingExamples";
import { Spacing } from "../Spacing/Spacing";
import { useTheme } from "../../design-system-fe/hooks/useTheme";
import { DarkModeIcon, LightModeIcon } from "../../components/icons";
import { Button } from "../Button/Button";
import { BorderExamples } from "../BorderExamples/BorderExamples";

type DesignSystemSection =
  | "typography"
  | "foundationColors"
  | "semanticColors"
  | "margin"
  | "padding"
  | "spacing"
  | "border"
  | "button";

const DesignSystemPage: React.FC = () => {
  const [activeSection, setActiveSection] =
    useState<DesignSystemSection>("typography");
  const { theme, toggleTheme } = useTheme();

  const renderSection = () => {
    switch (activeSection) {
      case "typography":
        return <Typography />;
      case "foundationColors":
        return <FoundationColors />;
      case "semanticColors":
        return <SemanticColors />;
      case "margin":
        return <MarginExamples />;
      case "padding":
        return <PaddingExamples />;
      case "spacing":
        return <Spacing />;
      case "border":
        return <BorderExamples />;
      case "button":
        return <Button />;
      default:
        return <Typography />;
    }
  };

  return (
    <div className={`design-system-page theme-${theme}`}>
      <div className="design-system-header">
        <div className="header-content">
          <div className="design-system-header-title">Design System 2024</div>
          <div className="theme-toggle" onClick={toggleTheme}>
            {theme === "light" ? (
              <>
                <DarkModeIcon /> <span>Dark Mode</span>
              </>
            ) : (
              <>
                <LightModeIcon /> <span>Light Mode</span>
              </>
            )}
          </div>
        </div>
      </div>

      <div className="design-system-content">
        <aside className="design-system-sidebar">
          <nav className="design-system-nav">
            <h2 className="heading-s">Foundation</h2>
            <ul className="design-system-nav-list">
              <li
                className={`design-system-nav-item ${activeSection === "typography" ? "active" : ""}`}
                onClick={() => setActiveSection("typography")}
              >
                Typography
              </li>
              <li
                className={`design-system-nav-item ${activeSection === "foundationColors" ? "active" : ""}`}
                onClick={() => setActiveSection("foundationColors")}
              >
                Foundation Colors
              </li>
              <li
                className={`design-system-nav-item ${activeSection === "semanticColors" ? "active" : ""}`}
                onClick={() => setActiveSection("semanticColors")}
              >
                Semantic Colors
              </li>
            </ul>

            <h2 className="heading-s">Spacing</h2>
            <ul className="design-system-nav-list">
              <li
                className={`design-system-nav-item ${activeSection === "spacing" ? "active" : ""}`}
                onClick={() => setActiveSection("spacing")}
              >
                Spacing Scale
              </li>
              <li
                className={`design-system-nav-item ${activeSection === "margin" ? "active" : ""}`}
                onClick={() => setActiveSection("margin")}
              >
                Margin
              </li>
              <li
                className={`design-system-nav-item ${activeSection === "padding" ? "active" : ""}`}
                onClick={() => setActiveSection("padding")}
              >
                Padding
              </li>
              <li
                className={`design-system-nav-item ${activeSection === "border" ? "active" : ""}`}
                onClick={() => setActiveSection("border")}
              >
                Border
              </li>
            </ul>
            <h2 className="heading-s">Components</h2>
            <ul className="design-system-nav-list">
              <li
                className={`design-system-nav-item ${activeSection === "button" ? "active" : ""}`}
                onClick={() => setActiveSection("button")}
              >
                Button
              </li>
            </ul>
          </nav>
        </aside>

        <main className="design-system-main">{renderSection()}</main>
      </div>
    </div>
  );
};

export default DesignSystemPage;
